import { requests } from '../../api/services';
import { INVOICING_URL } from '../../utils/Endpoints';
import { IInvoice } from '../../model/invoice/Invoices';

export const InvoiceService = {
    getInvoices: (params: any) => requests.get(`${INVOICING_URL}`, params),
    getInvoicesV2: (params: any) => requests.get(`${INVOICING_URL}/v2`, params),
    getLongTermInvoices: (params: any) => requests.get(`${INVOICING_URL}/contracts`, params),
    togglePaid: (id: number) => requests.put(`${INVOICING_URL}/toggle/paid/${id}`, {}),
    toggleDiscussion: (id: number) => requests.put(`${INVOICING_URL}/toggle/discussion/${id}`, {}),
    toggleProcessed: (id: number) => requests.put(`${INVOICING_URL}/toggle/processed/${id}`, {}),
    getInvoice: (id: number) => requests.get(`${INVOICING_URL}/single/${id}`),
    rejectInvoice: (id: number, invoice: Partial<IInvoice>) => requests.put(`${INVOICING_URL}/reject/${id}`, invoice),
    verifyInvoice: (id: number) => requests.put(`${INVOICING_URL}/verify/${id}`, {}),
};
